import type { AnchorHTMLAttributes } from 'react';

import type { LinkProps } from 'react-router-dom';
import { Link } from 'react-router-dom';

import type { ButtonProps } from 'src/app/components/Elements/Button';
import Button from 'src/app/components/Elements/Button';

export interface LinkButtonProps
  extends Pick<ButtonProps, 'block' | 'fixedWidth' | 'style' | 'size' | 'type'>,
    Omit<LinkProps, 'style' | 'type'>,
    Omit<AnchorHTMLAttributes<HTMLAnchorElement>, 'style' | 'type'> {}

/**
 * Treat this as both a Link and a Button but the two will get combined into one.
 */
const LinkButton = ({ children, className, to, ...rest }: LinkButtonProps) => {
  return (
    <Button className={className} tag={Link} to={to} {...rest}>
      {children}
    </Button>
  );
};

export default LinkButton;
